/* eslint-disable import/order */
import {
  SmartAccountHeadingText,
  maxTablet, maxWidth, midMobile, midTablet,
  primaryColor, primaryFont, primaryHeadingColor, retina, scrollbar,
  smMobile,
  wMedium,
} from 'Utils/utilsStyle';
import styled from 'styled-components';
import SmallButton from 'Components/common/components/SmallButton';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/CompaniesSlice';
import {
  selectAccountFormLoading, selectAccountPlanHistory,
  selectAccountPlanOpen,
  selectAccountPlanPodcast,
  selectPodcastGenerating,
  selectPodcastListOfExecutives,
  selectPodcastPermission,
  selectSapListOfExecutives,
  selectSapSort, selectSapSortType, selectuserAccountDetails, showAccountHistory,
  showCreateNew,
  showPodcastTab,
} from 'Selector/CompaniesSelector';
import SmartPlanSvg from 'Components/common/assets/svgIcons/SmartPlanSvg';
import { CustomTabGilroy } from 'gilroy-global';
import HistoryIcon from 'Components/common/assets/svgIcons/HistoryIcon';
import SmartInputAddIcon from 'Components/common/assets/svgIcons/SmartInputAddIcon';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import SmartAccountDrawerTimeline from './SmartAccountDrawerTimeline';
import SmartAccountPlanHistoryTable from './SmartAccountPlanHistoryTable';
import PodcastGenerateIcon from 'Components/common/assets/svgIcons/PodcastGenerateIcon';
import { SAP_CREATE_DESCRIPTION, SAP_HISTORY_DESCRIPTION, SAP_PODCAST_DESCRIPTION } from 'Utils/Constants';

const Wrapper = styled.div`
  &.historyTab {
    height: calc(100% - 0px);
    overflow: hidden;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 70px);
  ${scrollbar};
  border-radius: 0 !important;
  @media all and (max-height: ${midTablet}) {
    height: calc(100% - 31px);
  }
  @media all and (max-width: ${maxTablet}) and (max-height: ${midTablet}) {
    height: calc(100% - 43px);;
  }
  .splash-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #DEF6E6;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
    padding: 47px 85px 16px;
    @media all and (max-width: ${midMobile}) {
      padding: 47px 20px 16px;
    }
    @media all and (max-height: ${midTablet}) {
      padding: 12px 85px 6px;
    }
    @media all and (max-width: ${smMobile}) {
      padding: 12px 50px 6px;
    }
    .smart-plan-svg{
      width: 46px;
      height: 40px;
      min-height: 40px;
      margin-bottom: 4px;
    }
    .heading-splash {
      ${SmartAccountHeadingText};
      text-align: center;
      leading-trim: both;
      text-edge: cap;
      font-size: 28px;
      margin-bottom: 5px;
      line-height: normal;
      @media all and (max-width:${maxWidth}), ${retina} {
        font-size: 26px;
        line-height: 20px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 24px;
      }
      @media all and (max-height: ${midTablet}) {
        font-size: 24px;
      }
      sup {
        font-size: 15px;
        top: -13px;
        @media all and (max-height: ${midTablet}) {
          font-size: 11px;
          top: -10px;
        }
      }
    }
    .description-splash {
      font-size: 14px;
      line-height: normal;
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      color: ${primaryHeadingColor};
      text-align: center;
      letter-spacing: -0.562px;
      @media all and (max-width:${maxWidth}), ${retina} {
        font-size: 14px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 13px;  
      }
      @media all and (max-height: ${midTablet}) {
        font-size: 12px;
      }
    }
  }
  .tabs-div {
    display: flex;
    width: calc(100% - 24px);
    border-radius: 6.019px;
    background: #DEF6E6;
    padding: 4px 5px;
    height: 40px;
    margin: 8px 12px;
    @media all and (max-height: ${midTablet}) {
      height: 36px;
      margin-bottom: 0px;
    }
    .gilroy-custom-tab {
      &.notActive { 
        .add-icon-svg {
          rect {
            fill: #DEF6E6;
          }
        }
      }
      font-size: 14px;
      @media all and (max-width: ${maxTablet}) {
        border-radius: 4px;
        font-size: 12px;
        line-height: 14px;
      }
      .podcast-generate-tab-icon {
        @media all and (max-width: ${maxTablet}) {
          width: 13px;
          height: 11px;
        }
      }
      .add-icon-svg {
        margin-right: 7px;
        width: 18px;
        height: 18px;
        @media all and (max-width: ${maxTablet}) {
          width: 13px;
          height: 11px;
          margin-right: 5px;
        }
      }
      .history-icon {
        margin-right: 7px;
        width: 13px;
        height: 15px;
        @media all and (max-width: ${maxTablet}) {
          width: 9px;
          height: 10px;
          margin-right: 5px;
        }
      }
    }
  }
  .overlayForDrawerOnly{
    background-color: rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    outline: 0;
    z-index: 1000;
  }
`;
const WrapperFooter = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(0, 0, 0, 0.14);
  background-color: #fff;
  width: 100%;
  padding: 16px 0;
  z-index: 1;
  @media all and (max-width:${maxWidth}), ${retina} {
    padding: 22px 0;
  }
  @media all and (max-width: ${maxTablet}) {
    bottom: 20px;
  }
  @media all and (max-height: ${midTablet}) {
    padding: 10px 0;
  }
`;

type Props = {
  setShowAccountPlanForm: (val: boolean) => void
  companyId: number
  effectiveCompanyId: number
  sapInitialized: boolean
};

const SmartAccountSplashScreen = function SmartAccountSplashScreen(props: Props) {
  const { companyId, effectiveCompanyId, setShowAccountPlanForm, sapInitialized } = props;
  const heading = 'Smart Account Plan';
  const dispatch = useDispatch();
  const formLoading = useSelector(selectAccountFormLoading);
  const accountPlanHistory = useSelector(selectAccountPlanHistory);
  const accountPlanPodcast = useSelector(selectAccountPlanPodcast);
  const sort = useSelector(selectSapSort);
  const sortType = useSelector(selectSapSortType);
  const showHistorySAP = useSelector(showAccountHistory);
  const showPodcastTabSAP = useSelector(showPodcastTab);
  const showCreateNewSAP = useSelector(showCreateNew);
  const limitPopup = useSelector(selectuserAccountDetails);
  const podcastPermission = useSelector(selectPodcastPermission);
  const [allowPopup, setAllowPopup] = useState(false);
  const podcastGenerating = useSelector(selectPodcastGenerating);
  const visible = useSelector(selectAccountPlanOpen);
  const podcastLength = useSelector(selectAccountPlanPodcast).length;
  const description = showHistorySAP ? SAP_HISTORY_DESCRIPTION
    : showPodcastTabSAP ? SAP_PODCAST_DESCRIPTION : SAP_CREATE_DESCRIPTION;
  const [podcastInitialized, setPodcastInitialized] = useState(false);
  const [sapListInitialized, setSapListInitialized] = useState(false);
  const [podcastListInitialized, setPodcastListInitialized] = useState(false);
  const sapListOfExecutives = useSelector(selectSapListOfExecutives);
  const podcastListOfExecutives = useSelector(selectPodcastListOfExecutives);
  const [selectedSapExecutives, setSelectedSapExectuives] = useState<number[]>([]);
  const [selectedPodcastExecutives, setSelectedPodcastExecutives] = useState<number[]>([]);
  const prevPodcastExecsRef = useRef(podcastListOfExecutives)
  const prevSapExecsRef = useRef(sapListOfExecutives);


  useEffect(() => {
    if (!sapListInitialized && sapListOfExecutives.length > 0) {
      setSelectedSapExectuives(sapListOfExecutives.map(exec => exec.userId));
      setSapListInitialized(true);
    } else {
      const previousExecs = new Set(prevSapExecsRef.current.map(exec => exec.userId));
      const newExecs = sapListOfExecutives.filter(exec =>
        !previousExecs.has(exec.userId));

      if (newExecs.length > 0) {
        setSelectedSapExectuives((prev) => [...prev, ...newExecs.map(exec => exec.userId)]);
      }
    }
    prevSapExecsRef.current = sapListOfExecutives;
  }, [sapListOfExecutives]);

  useEffect(() => {
    if (!podcastListInitialized && podcastListOfExecutives.length > 0) {
      setSelectedPodcastExecutives(podcastListOfExecutives.map(exec => exec.userId));
      setPodcastListInitialized(true);
    }
    else {
      const previousExecs = new Set(prevPodcastExecsRef.current.map(exec => exec.userId));
      const newExecs = podcastListOfExecutives.filter(exec => !previousExecs.has(exec.userId));

      if (newExecs.length > 0) {
        setSelectedPodcastExecutives((prev) => [...prev, ...newExecs.map(exec => exec.userId)]);
      }
    }
    prevPodcastExecsRef.current = podcastListOfExecutives;
  }, [podcastListOfExecutives])

  const toggleTabs = (index: number) => {
    if (index === 1) {
      dispatch(actions.setShowSAPHistory(false));
      dispatch(actions.setShowCreateNew(true));
      dispatch(actions.setShowPodcastTab(false));
    } else if (index === 2) {
      dispatch(actions.setShowSAPHistory(true));
      dispatch(actions.setShowCreateNew(false));
      dispatch(actions.setShowPodcastTab(false));
    } else if (index === 3) {
      // if (!podcastLength && !podcastGenerating) {
      //   dispatch(actions.setAccountPlanPodcastLoading(true));
      // }
      dispatch(actions.setShowSAPHistory(false));
      dispatch(actions.setShowCreateNew(false));
      dispatch(actions.setShowPodcastTab(true));
    }
  };

  useEffect(() => {
    if (allowPopup && limitPopup?.showPlanPopup === 3) {
      dispatch(actions.setAccountPlanDrawerOpen(false));
      dispatch(actions.setShowLimitPopupSAP(true));
      setShowAccountPlanForm(false);
      setAllowPopup(false);
    }
  }, [allowPopup, limitPopup]);

  useEffect(() => {
    if (!accountPlanHistory?.length && !showPodcastTabSAP && !sapInitialized) {
      dispatch(actions.getAccountPlanHistory({
        offset: accountPlanHistory?.length,
        sortType,
        sort,
        companyId,
        type: 'history',
      }));
    } else if (!accountPlanPodcast?.length && showPodcastTabSAP && !podcastInitialized) {
      dispatch(actions.getAccountPlanHistory({
        offset: accountPlanPodcast?.length,
        sortType,
        sort,
        companyId,
        type: 'podcast',
      }));
      setPodcastInitialized(true);
    }
  }, [showPodcastTabSAP, sort, sortType, sapInitialized, podcastInitialized]);

  useEffect(() => {
    if (podcastGenerating && podcastPermission && visible) {
      toggleTabs(3);
    }
  }, [podcastGenerating, podcastPermission, visible]);

  return (
    <Wrapper className={classNames({ historyTab: showHistorySAP })}>
      <div className="splash-header">
        <SmartPlanSvg color={primaryColor} />
        <h6 className="heading-splash">
          {heading}
          <sup>TM</sup>
        </h6>
        <div className="description-splash">{description}</div>
      </div>
      <div className="tabs-div">
        <CustomTabGilroy
          text="Create New"
          activeState={showCreateNewSAP || (!showHistorySAP && !showPodcastTabSAP)}
          leftIcon={<SmartInputAddIcon className="add-icon-svg" />}
          onClick={() => toggleTabs(1)}
          highlightedComponent={false}
        />
        <CustomTabGilroy
          text="History"
          activeState={showHistorySAP}
          leftIcon={<HistoryIcon />}
          onClick={() => toggleTabs(2)}
          highlightedComponent={false}
        />
        {podcastPermission ? (
          <CustomTabGilroy
            text="Podcast"
            activeState={showPodcastTabSAP}
            leftIcon={<PodcastGenerateIcon />}
            onClick={() => toggleTabs(3)}
            highlightedComponent={false}
          />
        ) : null}
      </div>
      {showHistorySAP || showPodcastTabSAP ? (
        <SmartAccountPlanHistoryTable
          key={`${showHistorySAP ? 'history' : 'podcast'}-${effectiveCompanyId}`}
          podcastGenerate={showPodcastTabSAP}
          sapListOfExecutives={sapListOfExecutives}
          podcastListOfExecutives={podcastListOfExecutives}
          selectedSapExecutives={selectedSapExecutives}
          setSelectedSapExectuives={setSelectedSapExectuives}
          selectedPodcastExecutives={selectedPodcastExecutives}
          setSelectedPodcastExecutives={setSelectedPodcastExecutives}
        />
      ) : (
        <>
          <SmartAccountDrawerTimeline />
          <WrapperFooter>
            <SmallButton
              title="Start"
              padding="6px 118px"
              paddingSm="6px 118px"
              borderRadius="24px"
              disabled={formLoading}
              onButtonClick={() => {
                setAllowPopup(true);
                dispatch(actions.getAccountPlanForm({ companyId: effectiveCompanyId }));
              }}
            />
          </WrapperFooter>
        </>
      )}
    </Wrapper>
  );
};

export default SmartAccountSplashScreen;